import { Component, OnInit,Output,EventEmitter,ElementRef,ViewChild } from '@angular/core';
import { GastroFormsService } from '../gastro-forms.service';
import { LoginService } from 'src/app/login.service';
import { RecoveryService } from '../recovery.service';
import { AutotextService } from '../autotext.service';
import { Subscription,fromEvent,Subject, } from 'rxjs';
import {  tap, switchMap, takeUntil, finalize} from 'rxjs/operators';

@Component({
    selector: 'app-recovery',
    templateUrl: './recovery.component.html',
    styleUrls: ['./recovery.component.scss'],
    standalone: false
})
export class RecoveryComponent implements OnInit {

  constructor(public gfs:GastroFormsService, private ls:LoginService,public gsf: RecoveryService,public atS:AutotextService) { }
  @Output() closed = new EventEmitter<string>();
  @Output() print = new EventEmitter<string>();
  private formLoadedSub: Subscription;
  @ViewChild("canvasSign", { static: true })
  canvasSign: ElementRef<HTMLCanvasElement>;
  changeCanvas$ = new Subject();
  destroy$ = new Subject();
  ctx: CanvasRenderingContext2D;

  ngOnInit(): void {
    this.formLoadedSub = this.gfs.formLoaded$.subscribe(
      (data: any) => {
        if (this.gfs.Form && this.gfs.Form.get('nurseSign').value) {
          this.loadSign();
        }})
  }

  close(toclose: boolean) {
    this.closed.emit(toclose ? '1': null);
  }

  printForm(){
    this.print.emit('1')
  }

  clear( name: string){
    if(! this.gfs.isClosed)
      this.gfs.Form.get(name).setValue('-1')
  }

  totalScore(){
   return this.gfs.Form.get('skinTone').value+this.gfs.Form.get('recognition').value+this.gfs.Form.get('Hemodynamics').value+this.gfs.Form.get('breathing').value+this.gfs.Form.get('mobility').value
  }
  clearSign() {
    var ctx = this.canvasSign.nativeElement.getContext("2d");
    ctx.clearRect(
      0,
      0,
      this.canvasSign.nativeElement.width,
      this.canvasSign.nativeElement.height
    );
    this.gfs
.Form.get('nurseSign').setValue('');
  
  
  }
  
  setCanvas() {
    this.ctx = this.canvasSign.nativeElement.getContext("2d");
    this.changeCanvas$.next({ canvas: this.canvasSign, ctx: this.ctx });
  }
  
  saveSign() {
    let canvasUrl = this.canvasSign.nativeElement.toDataURL("image/png");
        this.gfs
.Form.get("nurseSign").setValue(canvasUrl);
       
    }
  
    loadSign(){
      var ctx = this.canvasSign.nativeElement.getContext("2d");
        const imgNurseSign = document.createElement("img");
        imgNurseSign.onload = function () {
          ctx.drawImage(imgNurseSign, 0, 0); // Or at whatever offset you like
        };
        imgNurseSign.src = this.gfs
.Form.get("nurseSign").value;
    }

    ngAfterViewInit(){
      this.changeCanvas$
       .pipe(takeUntil(this.destroy$))
       .subscribe((data: any) => {
         this.ctx = data.ctx;
         const mouseDownStream = fromEvent(
           this.canvasSign.nativeElement,
           "mousedown"
         );
         const mouseMoveStream = fromEvent(
           this.canvasSign.nativeElement,
           "mousemove"
         );
         const mouseUpStream = fromEvent(window, "mouseup");
         mouseDownStream
           .pipe(
             tap((event: MouseEvent) => {
               this.ctx.beginPath();
               this.ctx.strokeStyle = "black";
               this.ctx.lineWidth = 5;
               this.ctx.lineJoin = "round";
               this.ctx.moveTo(event.offsetX, event.offsetY);
             }),
             switchMap(() =>
               mouseMoveStream.pipe(
                 tap((event: MouseEvent) => {
                   this.ctx.lineTo(event.offsetX, event.offsetY);
                   this.ctx.stroke();
                 }),
                 takeUntil(mouseUpStream),
                 finalize(() => {
                   // this.ctx.closePath();
                   this.saveSign();
                 })
               )
             )
           )
           .subscribe((data) => {
             // console.log(data);
           });
       });
   }
 

   ngOnDestroy(): void {
    if (this.formLoadedSub) {
      this.formLoadedSub.unsubscribe();
    }
    this.destroy$.next(undefined)
    this.destroy$.complete()
  }
}
